<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Centri di Selezione'
    }]"
  />
  <div class="flex justify-between mb-4">
    <div class="flex-grow">
      <SearchInput v-model="search" />
      <SearchSelect
        v-model="enabled"
        name="selection-site-enabled"
        :options="{ '1': 'Abilitato', '-1': 'Non Abilitato' }"
      />
    </div>

    <div class="self-end">
      <ActionButton
        v-if="authStore.canManageAuction"
        @click="router.push('/centri-selezione/crea')"
      >
        <PlusCircleIcon class="w-5 h-5 inline-block" />
        Crea nuovo Centro di Selezione
      </ActionButton>
    </div>
  </div>

  <DataTable :data="data">
    <template #heading>
      <tr>
        <SortableColumn
          v-model="sortStatus"
          name="displayName"
        >
          Nome
        </SortableColumn>

        <SortableColumn
          v-model="sortStatus"
          name="companyName"
        >
          Azienda
        </SortableColumn>

        <SortableColumn
          v-model="sortStatus"
          name="organizationCode"
        >
          Codice Organizzazione
        </SortableColumn>

        <SortableColumn
          v-model="sortStatus"
          name="enabled"
        >
          Abilitato
        </SortableColumn>

        <th class="text-right p-2" />
      </tr>
    </template>
    <template #body>
      <tr
        v-for="selectionSite in data"
        :key="'selection-site-table-' + selectionSite.uuid"
        class="odd:bg-gray-100"
      >
        <td class="p-2">
          {{ selectionSite.displayName }}
        </td>
        <td class="p-2">
          {{ selectionSite.companyName }}
        </td>
        <td class="p-2">
          {{ selectionSite.organizationCode }}
        </td>
        <td class="p-2">
          <WalletIcon
            class="h-6 w-6"
            :class="{ 'text-green-500': selectionSite.enabled, 'text-red-500': !selectionSite.enabled }"
          />
        </td>
        <td class="p-2 text-right">
          <RouterLink
            v-if="authStore.canManageAuction"
            title="Modifica Centro di Selezione"
            :to="'/centri-selezione/' + selectionSite.uuid"
          >
            <PencilSquareIcon class="h-5 w-5 inline-block mx-1" />
          </RouterLink>
          <a
            v-if="!selectionSite.enabled && authStore.canManageAuction"
            href="#"
            title="Abilita Centro di Selezione"
            @click="enable(selectionSite)"
          >
            <FaceSmileIcon class="h-5 w-5 inline-block mx-1 " />
          </a>

          <a
            v-if="selectionSite.enabled && authStore.canManageAuction"
            href="#"
            title="Disabilita Centro di Selezione"
            @click="disable(selectionSite)"
          >
            <FaceFrownIcon class="h-5 w-5 inline-block mx-1 " />
          </a>
        </td>
      </tr>
    </template>
  </DataTable>

  <DataTablePaginator
    :count="count"
    :count-all="countAll"
    :count-filtered="countFiltered"
    :current-page="currentPage"
    :has-next="hasNext"
    :has-prev="hasPrev"
    :next="next"
    :prev="prev"
    :total-pages="totalPages"
  />
</template>
    
<script setup>
import {
  FaceFrownIcon,
  FaceSmileIcon,
  PencilSquareIcon,
  PlusCircleIcon,
  WalletIcon} from "@heroicons/vue/24/outline";
import { ref, watch } from "vue";
import { useRouter } from 'vue-router'

import ActionButton from "@/components/ActionButton.vue";
import DataTable from "@/components/list/DataTable.vue";
import DataTablePaginator from "@/components/list/DataTablePaginator.vue";
import SearchInput from "@/components/list/SearchInput.vue";
import SearchSelect from "@/components/list/SearchSelect.vue";
import SortableColumn from "@/components/list/SortableColumn.vue";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useDataTable from '@/composables/datatable.js'
import { useAuthStore } from '@/stores/auth'

const router = useRouter()
const authStore = useAuthStore()

const search = ref('')
const enabled = ref(null)

const sortStatus = ref(["displayName", -1]);

const { data, count, countFiltered, countAll, currentPage, totalPages, next, prev, hasPrev, hasNext, doFilter, action } = await useDataTable({
  endpoint: "/selection-site/list",
  sortStatus,
  search,
  searchProperties: ['displayName'],
  extraFilter: (item) => {
    return enabled.value == 1 ? item.enabled : (enabled.value == -1 ? !item.enabled : true);
  }
})

watch(enabled, () => {
  doFilter()
})

const enable = (selectionSite) => {
  action('put', 'selection-site/enable/' + selectionSite.uuid, 'Centro di Selezione abilitato con successo')
}

const disable = (selectionSite) => {
  action('put', 'selection-site/disable/' + selectionSite.uuid, 'Centro di Selezione disabilitato con successo')
}

</script>
